import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   data: import('./data').GatesDataEntity,
 *   ui: import('./ui').GateUIReducer
 * }} GatesReducer
 */
export default combineReducers({
  data,
  ui,
});
